/* eslint-disable no-useless-escape */
/* eslint-disable react-hooks/exhaustive-deps */
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";
import { CirclePlus, Trash2 } from "lucide-react";
import { Fragment, useEffect, useState } from "react";
// import { ExpressionSelect } from "./expression-select";
import { ExpressionSelect2 } from "./expression-select2";
import { OperatorSelection } from "./operator-selection";

/* eslint-disable @typescript-eslint/no-explicit-any */
type ExpressionInput = {
  bindLabel: string;
  bindValue: string;
  options: any[];
  value: string;
  isEnable: boolean;
  onChange: (prop: any) => void;
};
export const ExpressionInput = ({
  value,
  bindLabel,
  bindValue,
  options,
  isEnable,
  onChange,
}: ExpressionInput) => {
  const [expressionList, setExpressionList] = useState<any[]>([]);

  function parseExpression(expression: string) {
    const operators = [
      "===",
      "!==",
      ">=",
      "<=",
      "==",
      "!=",
      ">",
      "<",
      "+",
      "-",
      "*",
      "/",
    ];

    const operatorPattern = operators
      .map((op) => op.replace(/([.*+?^=!:${}()|\[\]\/\\])/g, "\\$1"))
      .join("|");
    const regex = new RegExp(`\\s*(${operatorPattern})\\s*`);

    const parts = expression.split(regex).filter((part) => part.trim() !== "");

    const result: { label: string; operator: string }[] = [];

    for (let i = 0; i < parts.length; i += 2) {
      const label = parts[i].trim();
      const operator = parts[i + 1]?.trim() ?? "";
      result.push({ label, operator });
    }

    // ✅ Enforce "+" as last operator if it's empty
    if (result.length > 0) {
      const last = result[result.length - 1];
      if (!last.operator || last.operator.trim() === "") {
        last.operator = "+";
      }
    }

    return result;
  }

  // function parseExpression(expression: string) {
  //   const operators = [
  //     "===",
  //     "!==",
  //     ">=",
  //     "<=",
  //     "==",
  //     "!=",
  //     ">",
  //     "<",
  //     "+",
  //     "-",
  //     "*",
  //     "/",
  //   ];
  //   const operatorPattern = operators
  //     .map((op) => op.replace(/([.*+?^=!:${}()|\[\]\/\\])/g, "\\$1"))
  //     .join("|");
  //   const regex = new RegExp(`\\s*(${operatorPattern})\\s*`);

  //   const parts = expression.split(regex).filter((part) => part.trim() !== "");

  //   const result = [];
  //   for (let i = 0; i < parts.length; i += 2) {
  //     const label = parts[i].trim();
  //     const operator = parts[i + 1] ? parts[i + 1].trim() : "";
  //     result.push({ label, operator });
  //   }

  //   // Ensure the last item has operator: ""
  //   if (result.length > 0) {
  //     result[result.length - 1].operator = "";
  //   }

  //   return result;
  // }

  useEffect(() => {
    if (typeof value === "string") {
      // const list = value?.split("+").map((item) => item.trim());
      const new_str = value;
      const list = parseExpression(value);
      console.log({ new_str });
      console.log({ list });
      if (Array.isArray(list)) {
        setExpressionList(list);
        // setExpressionList([]);
      }
    }
  }, [value]);

  useEffect(() => {
    onChange(expressionList);
  }, [expressionList]);

  const onChangeHandle = ({
    data,
    index,
    type,
  }: {
    data: string;
    index: number;
    type: "label" | "operator";
  }) => {
    const updatedList = expressionList.map((item: any, i: number) => {
      if (i === index) {
        if (type === "label") {
          return { ...item, label: data };
        } else {
          return { ...item, operator: data };
        }
      }
      return item;
    });
    setExpressionList(updatedList);
  };

  const addNewExpression = () => {
    setExpressionList([...expressionList, { label: "", operator: "+" }]);
  };
  const removeExpression = (index: number) => {
    const updatedList = expressionList.filter((_item, i) => i !== index);
    setExpressionList(updatedList);
  };
  return (
    <>
      <div
        className={cn(
          "flex flex-col gap-4 border p-4 rounded-md max-h-[300px] overflow-y-auto",
          isEnable ? "" : "opacity-65 pointer-events-none"
        )}
      >
        {/* <pre>{JSON.stringify(expressionList, null, 2)}</pre> */}
        {expressionList?.map((item: any, index: number, arr: any[]) => {
          return (
            <Fragment key={index}>
              <div className={cn("flex items-center")}>
                <ExpressionSelect2
                  bindLabel={bindLabel}
                  bindValue={bindValue}
                  options={options}
                  value={item.label}
                  defaultValue={item.label}
                  placeholder="Select Expression"
                  onChange={(prop: string) =>
                    onChangeHandle({ data: prop, index, type: "label" })
                  }
                />
                <div className={cn("flex", index === 0 ? "" : "pl-3")}>
                  {index === 0 ? null : (
                    <Button
                      type="button"
                      onClick={() => removeExpression(index)}
                      size={"icon"}
                      variant={"outline"}
                    >
                      <Trash2 />
                    </Button>
                  )}

                  {arr.length === index + 1 ? (
                    <>
                      <Button
                        size={"icon"}
                        onClick={() => addNewExpression()}
                        className="ml-3"
                        variant={"ghost"}
                        type="button"
                        disabled
                      >
                        {" "}
                      </Button>
                    </>
                  ) : (
                    <>
                      <OperatorSelection
                        operator={item.operator}
                        onChange={(prop: string) =>
                          onChangeHandle({
                            data: prop,
                            index,
                            type: "operator",
                          })
                        }
                      />
                    </>
                    // <Button
                    //   size={"icon"}
                    //   variant={"ghost"}
                    //   className="pointer-events-none ml-3"
                    //   type="button"
                    // >
                    //   {displayOperator(item.operator)}
                    // </Button>
                  )}
                </div>
              </div>
              {/* <div key={index} className={cn("flex items-center")}>
              <ExpressionSelect
                bindLabel={bindLabel}
                bindValue={bindValue}
                options={options}
                value={item}
                defaultValue={item}
                placeholder="Select Expression"
                onChange={(prop: string) =>
                  onChangeHandle({ data: prop, index })
                }
              />
              <div className={cn("flex", index === 0 ? "" : "pl-3")}>
                {index === 0 ? null : (
                  <Button
                    type="button"
                    onClick={() => removeExpression(index)}
                    size={"icon"}
                    variant={"outline"}
                  >
                    <Trash2 />
                  </Button>
                )}

                {arr.length === index + 1 ? (
                  <Button
                    size={"icon"}
                    onClick={() => addNewExpression()}
                    className="ml-3"
                    variant={"outline"}
                    type="button"
                  >
                    <CirclePlus />
                  </Button>
                ) : (
                  <Button
                    size={"icon"}
                    variant={"ghost"}
                    className="pointer-events-none ml-3"
                    type="button"
                  >
                    <Plus />
                  </Button>
                )}
              </div>
            </div> */}
            </Fragment>
          );
        })}
        {expressionList.length === 0 ? (
          <div className="text-sm text-gray-500">Please add expression</div>
        ) : null}
      </div>
      <div className="flex items-center justify-end">
        <Button
          onClick={() => addNewExpression()}
          className="ml-3"
          variant={"outline"}
          type="button"
        >
          Add <CirclePlus />
        </Button>
      </div>
    </>
  );
};

// /* eslint-disable react-hooks/exhaustive-deps */
// import { Button } from "@/components/ui/button";
// import { cn } from "@/lib/utils";
// import { CirclePlus, Plus, Trash2 } from "lucide-react";
// import { useEffect, useState } from "react";
// import { ExpressionSelect } from "./expression-select";

// /* eslint-disable @typescript-eslint/no-explicit-any */
// type ExpressionInput = {
//   bindLabel: string;
//   bindValue: string;
//   options: any[];
//   value: string;
//   isEnable: boolean;
//   onChange: (prop: any) => void;
// };
// export const ExpressionInput = ({
//   value,
//   bindLabel,
//   bindValue,
//   options,
//   isEnable,
//   onChange,
// }: ExpressionInput) => {
//   const [expressionList, setExpressionList] = useState<any[]>([]);

//   useEffect(() => {
//     if (typeof value === "string") {
//       const list = value?.split("+").map((item) => item.trim());
//       if (list) {
//         setExpressionList(list);
//       }
//     }
//   }, [value]);

//   useEffect(() => {
//     onChange(expressionList);
//   }, [expressionList]);

//   const onChangeHandle = ({ data, index }: { data: string; index: number }) => {
//     const updatedList = expressionList.map((item: string, i: number) => {
//       if (i === index) {
//         return data;
//       }
//       return item;
//     });
//     setExpressionList(updatedList);
//   };

//   const addNewExpression = () => {
//     setExpressionList([...expressionList, ""]);
//   };
//   const removeExpression = (index: number) => {
//     const updatedList = expressionList.filter((_item, i) => i !== index);
//     setExpressionList(updatedList);
//   };
//   return (
//     <>
//       <div
//         className={cn(
//           "flex flex-col gap-4 border p-4 rounded-md max-h-[300px] overflow-y-auto",
//           isEnable ? "" : "opacity-65 pointer-events-none"
//         )}
//       >
//         {expressionList?.map((item: any, index: number, arr: any[]) => {
//           return (
//             <>
//               <div key={index} className={cn("flex items-center")}>
//                 <ExpressionSelect
//                   bindLabel={bindLabel}
//                   bindValue={bindValue}
//                   options={options}
//                   value={item}
//                   defaultValue={item}
//                   placeholder="Select Expression"
//                   onChange={(prop: string) =>
//                     onChangeHandle({ data: prop, index })
//                   }
//                 />
//                 <div className={cn("flex", index === 0 ? "" : "pl-3")}>
//                   {index === 0 ? null : (
//                     <Button
//                       type="button"
//                       onClick={() => removeExpression(index)}
//                       size={"icon"}
//                       variant={"outline"}
//                     >
//                       <Trash2 />
//                     </Button>
//                   )}

//                   {arr.length === index + 1 ? (
//                     <>
//                       <Button
//                         size={"icon"}
//                         onClick={() => addNewExpression()}
//                         className="ml-3"
//                         variant={"ghost"}
//                         type="button"
//                         disabled
//                       >
//                         {" "}
//                       </Button>
//                     </>
//                   ) : (
//                     <Button
//                       size={"icon"}
//                       variant={"ghost"}
//                       className="pointer-events-none ml-3"
//                       type="button"
//                     >
//                       <Plus />
//                     </Button>
//                   )}
//                 </div>
//               </div>
//               {/* <div key={index} className={cn("flex items-center")}>
//               <ExpressionSelect
//                 bindLabel={bindLabel}
//                 bindValue={bindValue}
//                 options={options}
//                 value={item}
//                 defaultValue={item}
//                 placeholder="Select Expression"
//                 onChange={(prop: string) =>
//                   onChangeHandle({ data: prop, index })
//                 }
//               />
//               <div className={cn("flex", index === 0 ? "" : "pl-3")}>
//                 {index === 0 ? null : (
//                   <Button
//                     type="button"
//                     onClick={() => removeExpression(index)}
//                     size={"icon"}
//                     variant={"outline"}
//                   >
//                     <Trash2 />
//                   </Button>
//                 )}

//                 {arr.length === index + 1 ? (
//                   <Button
//                     size={"icon"}
//                     onClick={() => addNewExpression()}
//                     className="ml-3"
//                     variant={"outline"}
//                     type="button"
//                   >
//                     <CirclePlus />
//                   </Button>
//                 ) : (
//                   <Button
//                     size={"icon"}
//                     variant={"ghost"}
//                     className="pointer-events-none ml-3"
//                     type="button"
//                   >
//                     <Plus />
//                   </Button>
//                 )}
//               </div>
//             </div> */}
//             </>
//           );
//         })}
//       </div>
//       <div className="flex items-center justify-end">
//         <Button
//           onClick={() => addNewExpression()}
//           className="ml-3"
//           variant={"outline"}
//           type="button"
//         >
//           Add <CirclePlus />
//         </Button>
//       </div>
//     </>
//   );
// };
